<template>
    <div class="div-bg">
        <el-container v-show="!is_jump">
            <el-main>
                <!-- <img src="../assets/images/login_bg.png" -->
                <!-- style="border: 0;width: 100%;height: 100%;position: absolute;left: 0;top: 0;right: 0;bottom: 0;z-index: -999;"> -->
                <div style="min-height: 600px;" ref="refLoginDiv" :style="{marginTop:panelMarginTop+'px'}">
                    <div style="text-align: center;">
                        <img src="../../assets/images/heng_dian.png" alt="" style="width: 270px;height: 55px;">
                    </div>
                    <div style="display: flex;justify-content: center;align-items: center;margin-top: 1em;">
                        <el-card style="width: 620px;padding-bottom: 20px;">
                            <p style="font-weight: bolder;font-size: 24px;text-align: center;margin-top: 40px;">登录恒点MOOL
                            </p>
                            <p class="login-type-p">
                                <span :class="{loginSelected:typeMobileSelected}" @click="check('mobile')">账号登录</span>
                                <span :class="{loginSelected:typeNumberSelected}" style="margin-left: 75px;"
                                      @click="check('number')">学号登录</span>
                            </p>
                            <div style="text-align: center;padding-left: 90px;padding-right: 90px;">
                                <el-form :model="formMobile" :rules="ruleMobile" @submit.native.prevent>
                                    <el-form-item class="formItem" prop="mobile" v-if="typeMobileSelected">
                                        <el-input placeholder="请输入手机号/邮箱/用户名" prefix-icon="iconfont icon-shouji"
                                                  class="formInput"
                                                  ref="mobile" v-model="formMobile.mobile">
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                                <el-form :model="formNumber" style="padding-top: 25px;" v-if="typeNumberSelected"
                                         @submit.native.prevent>
                                    <sub-school @getSchoolId="fetchSchoolId" preIcon="iconfont icon-bank"></sub-school>
                                    <el-form-item class="formItem" prop="number" :rules="typeNumberSelected ? [{
                        required: true,
                        message: '请输入学号',
                        trigger: 'blur'
                    }]:[]">
                                        <el-input placeholder="请输入学号" prefix-icon="iconfont icon-yanzhengma1"
                                                  class="formInput"
                                                  v-model="formNumber.number">
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                                <el-form :model="formPassword" @submit.native.prevent>
                                    <el-form-item class="formItem" prop="password" :rules="[
                                {
                                    required: true,
                                    message: '请输入密码',
                                    trigger: 'blur'
                                }
                            ]">
                                        <el-input type="password" placeholder="请输入密码" prefix-icon="iconfont icon-key"
                                                  class="formInput"
                                                  v-model="formPassword.password" @keyup.enter.native="login">
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                                <el-button type="primary" style="width: 400px;margin-top: 25px;" @click="login">登录
                                </el-button>
                                <el-row style="color: #999999;margin-top: 10px;font-size: 12px;">
                                    <el-col :span="12" style="text-align: left;">
                                        <router-link style="" class="go-lost-password"
                                                     :to="{path:'/get-back-password'}">
                                            忘记密码
                                        </router-link>
                                    </el-col>
                                    <el-col :span="12" style="text-align: right;" v-if="registerType > 0">
                                        <span>还没有账号？</span>
                                        <span class="spanA" @click="register">点击注册</span>
                                    </el-col>
                                </el-row>
                            </div>
                            <div style="" v-if="thirdLoginWx || thirdLoginQq || thirdLoginWb">
                                <div style="text-align: center;margin-top: 25px;">
                                    <span class="thirdLine"></span>
                                    <span class="thirdText">第三方登录</span>
                                    <span class="thirdLine"></span>
                                </div>
                                <div class="thirdLoginSwitch" style="text-align: center;margin-top: 20px;">
                                    <i class="iconfont icon-QQ" :style="{backgroundColor:qqBgColor}"
                                       @mouseenter="thirdMouseOn('qq')" @mouseleave="thirdMouseOff('qq')"
                                       @click="loginWith('qq')" v-if="thirdLoginQq"></i>
                                    <i class="iconfont icon-wechat-fill" :style="{backgroundColor:wxBgColor}"
                                       @mouseenter="thirdMouseOn('wx')" @mouseleave="thirdMouseOff('wx')"
                                       @click="loginWith('wx')" v-if="thirdLoginWx"></i>
                                    <i class="iconfont icon-weibo1" :style="{backgroundColor:wbBgColor}"
                                       @mouseenter="thirdMouseOn('wb')" @mouseleave="thirdMouseOff('wb')"
                                       @click="loginWith('wb')" v-if="thirdLoginWb"></i>
                                </div>
                            </div>
                        </el-card>
                    </div>
                </div>
            </el-main>
            <el-footer>
                <hd-footer></hd-footer>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
import HdFooter from '../public/Footer.vue'
import SubSchool from '../public/sub/SubSchool.vue'

export default {
    name: 'login',
    components: {
        HdFooter,
        SubSchool
    },
    created () {
        //判断是否有jwt，如果有jwt，则表明可能从其他应用跳转
        let params = this.getParams()
        if (params.hasOwnProperty('jwt') && params.hasOwnProperty('url')) {
            this.is_jump = true
            let jwt = params.jwt
            //jwt替换+
            jwt = jwt.replace('+', ' ')
            //写入
            this.setJwt(jwt)
            let that = this
            //判断jwt的有效性
            this.$ajax.get('/api/user/get').then(function (r) {
                //跳转到对应的地址，强制替换
                window.location.replace('/#' + params.url)
            })
        } else {
            this.getPublicKey()
            this.getConfig()
            this.is_jump = false
            //删除登录信息
            this.logout()
            //获取跳转地址
            this.setUrl()
        }
    },
    data () {
        return {
            is_jump: true,
            ruleMobile: {
                mobile: [
                    {
                        required: true,
                        message: '请输入手机号/邮箱/用户名',
                        trigger: 'blur'
                    }
                ]
            },
            panelMarginTop: 0,
            typeMobileSelected: true,
            typeNumberSelected: false,
            thirdQQSelected: false,
            thirdWxSelected: false,
            thirdWbSelected: false,
            schoolId: 0,
            qqBgColor: '#D6D6DA',
            wxBgColor: '#D6D6DA',
            wbBgColor: '#D6D6DA',
            publicKey: '',
            publicMd5: '',
            formMobile: {
                mobile: ''
            },
            formNumber: {
                number: ''
            },
            formPassword: {
                password: '',
            },
            registerType: 0,
            thirdLoginWx: 0,
            thirdLoginQq: 0,
            thirdLoginWb: 0
        }
    },
    mounted () {
        this.$nextTick(function () {
            this.setPanelPosition()
        })
        this.$refs.mobile.focus()
    },
    methods: {
        getConfig () {
            let that = this
            this.$ajax.get('/api/configsystem/getbynames', {
                params: {
                    'names': [
                        'third_login_wx',
                        'third_login_qq',
                        'third_login_wb',
                        'register_type'
                    ]
                }
            }).then(function (r) {
                Object.keys(r.data.items).forEach(function (key) {
                    let v = r.data.items[key]
                    switch (key) {
                        case 'register_type':
                            that.registerType = v
                            break
                        case 'third_login_wx':
                            that.thirdLoginWx = v
                            break
                        case 'third_login_qq':
                            that.thirdLoginQq = v
                            break
                        case 'third_login_wb':
                            that.thirdLoginWb = v
                            break
                    }
                })
            })
        },
        setUrl () {
            let params = this.getParams()
            if (params.hasOwnProperty('url')) {
                localStorage.setItem('jump_url', params.url)
            }
            let mobile = localStorage.getItem('mobile')
            if (mobile) {
                this.formMobile.mobile = localStorage.getItem('mobile')
            }
            let password = localStorage.getItem('password')
            if (password) {
                this.formPassword.password = password
            }
        },
        check: function (type) {
            if (type == 'mobile') {
                if (this.typeMobileSelected) {
                    return
                } else {
                    this.typeMobileSelected = true
                    this.typeNumberSelected = false
                }
                let that = this
                setTimeout(function () {
                    that.$refs.mobile.focus()
                }, 100)
            } else {
                if (this.typeNumberSelected) {
                    return
                } else {
                    this.typeNumberSelected = true
                    this.typeMobileSelected = false
                }
            }
        },
        thirdMouseOn: function (type) {
            switch (type) {
                case 'qq':
                    this.qqBgColor = '#3399ff'
                    break
                case 'wx':
                    this.wxBgColor = '#00cc00'
                    break
                case 'wb':
                    this.wbBgColor = '#ff6666'
                    break
            }
        },
        thirdMouseOff: function (type) {
            let bgColor = '#D6D6DA'
            switch (type) {
                case 'qq':
                    this.qqBgColor = bgColor
                    break
                case 'wx':
                    this.wxBgColor = bgColor
                    break
                case 'wb':
                    this.wbBgColor = bgColor
                    break
            }
        },
        loginWith: function (type) {
            console.log('login with: ', type)
        },
        setPanelPosition: function () {
            let h = this.$refs.refLoginDiv.offsetHeight
            this.panelMarginTop = this.getClientTop(h)
        },
        //忘记密码
        forgetPassword: function () {

        },
        //注册
        register: function () {
            let path = '/register'
            if (this.registerType === 2) {
                //邮箱注册
                path = '/register-email'
            }
            this.$router.push({
                path: path
            })
        },
        //获取选中的学校id
        fetchSchoolId: function (id) {
            this.schoolId = id
        },
        getPublicKey () {
            let that = this
            this.$ajax.get('/api/rsa/getpublickey').then(function (res) {
                that.publicKey = res.data.public
                that.publicMd5 = res.data.public_md5
            })
            setTimeout(function () {
                if (that.isEmpty(that.publicKey)) {
                    //再次调用
                    that.getPublicKey()
                }
            }, 3000)
        },
        login () {
            let that = this
            let password = this.formPassword.password
            if (this.typeMobileSelected) {
                //手机号密码登录
                let mobile = this.formMobile.mobile
                if (this.isEmpty(mobile)) {
                    this.$message.error('请输入手机号/邮箱/用户名')
                    return
                }
                if (this.isEmpty(password)) {
                    this.$message.error('请输入密码')
                    return
                }
                this.$ajax.post('/api/user/login', {
                    mobile: mobile,
                    password: this.rsaEncode(password, this.publicKey),
                    public_md5: this.publicMd5
                }).then(function (res) {
                    if (res.data.hasOwnProperty('public')) {
                        //密钥失效
                        that.publicKey = res.data.public
                        that.publicMd5 = res.data.public_md5
                        //再次提交
                        that.login()
                    } else {
                        let jwt = res.data.jwt
                        that.setJwt(jwt)
                        that.cookieAdd('jwt', jwt, 30 * 24 * 3600)
                        //跳转至对应的地址
                        that.jumpThird(jwt)
                    }
                })
            } else {
                //学号登录
                if (this.isEmpty(this.schoolId)) {
                    this.$message.error('请选择学校')
                    return
                }
                if (this.isEmpty(this.formNumber.number)) {
                    this.showError('请输入学号')
                    return
                }
                if (this.isEmpty(password)) {
                    this.$message.error('请输入密码')
                    return
                }
                this.$ajax.post('/api/user/loginwithnumber', {
                    school_id: this.schoolId,
                    number: this.formNumber.number,
                    password: this.rsaEncode(password, this.publicKey),
                    public_md5: this.publicMd5
                }).then(function (res) {
                    if (res.data.hasOwnProperty('public')) {
                        //密钥失效
                        that.publicKey = res.data.public
                        that.publicMd5 = res.data.public_md5
                        //再次提交
                        that.login()
                    } else {
                        let jwt = res.data.jwt
                        that.setJwt(jwt)
                        that.cookieAdd('jwt', jwt, 30 * 24 * 3600)
                        console.log('jwt_time:', (new Date()).getTime());
                        that.cookieAdd('jwt_time', (new Date()).getTime() / 1000, 30 * 24 * 3600)
                        //跳转至对应的地址
                        that.jumpThird(jwt)
                    }
                })
            }
        },
        jumpThird (jwt) {
            let jumpUrl = localStorage.getItem('jump_url')
            //如果存在跳转地址，则跳转
            if (jumpUrl && jumpUrl !== 'null' && jumpUrl.length > 0) {
                if (this.getPrimaryDomain(window.location.host) !== this.getPrimaryDomain(jumpUrl)) {
                    //编码
                    jwt = encodeURIComponent(jwt)
                    if (jumpUrl.indexOf('?') === -1) {
                        jumpUrl += '?'
                    } else {
                        jumpUrl += '&'
                    }
                    jumpUrl += 'jwt=' + jwt
                }
                //删除跳转地址
                localStorage.removeItem('jump_url')
                //跳转
                window.location.href = jumpUrl
            } else {
                //否则跳转至用户中心
                this.$router.push({
                    path: '/user-center'
                })
            }
        },
        getRegister () {
            let that = this
            this.$ajax.get('/api/configsystem/getbyname', {
                params: {
                    name: 'register_type'
                }
            }).then(function (r) {
                that.registerType = r.data.value
            })
        }
    }

}
</script>

<style type="text/css" scoped="scoped">

.el-container {
    min-height: 95vh;
}

.div-bg {
    background-image: url(../../assets/images/login_bg.png);
    border: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
}

.login-type-p {
    font-size: 16px;
    text-align: center;
}

.login-type-p span {
    cursor: pointer;
    padding-bottom: 3px;
}


.loginSelected {
    border-bottom: 1px solid #00a4e0;
    color: #00a4e0;
}

.formInput {
    margin-top: 25px;
}

.thirdText {
    font-size: 12px;
    color: #999999;
    vertical-align: middle;
    vertical-align: -20%;
    margin-left: 30px;
    margin-right: 30px;
}

.thirdLine {
    display: inline-block;
    width: 135px;
    border-top: 1px solid #EEEEEE;
}

.thirdLoginSwitch i {
    font-size: 30px;
    cursor: pointer;
    padding: 5px;
    background-color: #D6D6DA;
    border-radius: 50%;
    color: #FFFFFF;
    margin-left: 25px;
    margin-right: 25px;
}

.thirdLoginSwitch img {
    cursor: pointer;
}

.go-lost-password {
    color: #999999;
    text-decoration: none;
}

.go-lost-password:hover,
.go-lost-password:visited {
    color: #999999;
}

.go-register {
    color: #00a4e0;
    text-decoration: none;
}

.formItem {
    margin-bottom: 0;
}

.spanA {
    color: #00a4e0;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue